(()=>{
 let busy=false,sequence=0;
 const root=window.Shopify?.routes?.root||'/';
 const copy=window.LUMY_CART_SIZE_COPY||{};
 const sizeLabel=v=>v.label;
 const request=async(path,body)=>{
  const response=await fetch(root+path,{method:body?'POST':'GET',credentials:'same-origin',headers:{'Content-Type':'application/json'},...(body?{body:JSON.stringify(body)}:{})});
  const data=await response.json();
  if(!response.ok)throw Error(data.description||copy.failed||'Unable to update size. Please try again.');
  return data;
 };
 window.LUMY_APPEND_CART_SIZE=(details,item,render)=>{
  if(!window.LUMY_IS_MAIN_VARIANT?.(item.variant_id))return;
  const variants=window.LUMY_VARIANTS?.length?window.LUMY_VARIANTS:[];
  if(variants.length<=1)return;
  const all=window.LUMY_SOURCES?.flatMap(source=>source.variants)||variants;
  const chosen=all.find(v=>String(v.id)===String(item.variant_id));
  const row=document.createElement('div');row.className='lumy-cart-size';
  const label=document.createElement('label');label.textContent=copy.size||'Size';
  const select=document.createElement('select');select.id='lumy-cart-size-'+(++sequence);select.className='lumy-size-select';label.htmlFor=select.id;
  select.setAttribute('aria-label',label.textContent+'. '+item.product_title);
  if(!chosen){const placeholder=document.createElement('option');placeholder.value='';placeholder.textContent=copy.choose||'Choose a size';placeholder.disabled=true;placeholder.selected=true;select.append(placeholder)}
  for(const variant of variants){const option=document.createElement('option');option.value=variant.id?String(variant.id):'preview-'+variant.label;option.textContent=sizeLabel(variant);option.disabled=!variant.id||!variant.available;option.selected=!!chosen&&String(variant.id)===String(chosen.id);select.append(option)}
  const error=document.createElement('p');error.className='lumy-cart-size-error';error.hidden=true;error.setAttribute('role','alert');
  const previous=select.value;
  select.addEventListener('change',async()=>{
   if(busy){select.value=previous;return}
   const target=variants.find(v=>String(v.id)===select.value);
   if(!target?.id||!target.available){select.value=previous;return}
   busy=true;row.setAttribute('aria-busy','true');error.hidden=true;
   const drawer=document.querySelector('#cart-drawer'),form=document.querySelector('#LumyrazeCartForm');
   for(const area of [drawer,form])if(area){area.inert=true;area.setAttribute('aria-busy','true')}
   let addedKey=null,added=false;
   try{
    const current=await request('cart.js');const source=current.items.find(line=>line.key===item.key);
    if(!source)throw Error(copy.changed||'Your cart changed. Refresh and try again.');
    const matches=current.items.filter(line=>String(line.variant_id)===String(target.id));
    const plain=!source.selling_plan_allocation&&!Object.keys(source.properties||{}).length&&matches.every(line=>!line.selling_plan_allocation&&!Object.keys(line.properties||{}).length);
    if(plain){
     const quantity=source.quantity+matches.reduce((sum,line)=>sum+line.quantity,0);
     if(Number.isFinite(target.stock)&&quantity>target.stock)throw Error('Not enough stock for this collection.');
     const updated=await request('cart/update.js',{updates:{[source.variant_id]:0,[target.id]:quantity}});
     render(updated);return;
    }
    const addition={id:Number(target.id),quantity:source.quantity,properties:source.properties||{}};
    if(source.selling_plan_allocation)addition.selling_plan=source.selling_plan_allocation.selling_plan.id;
    const result=await request('cart/add.js',{items:[addition]});added=true;addedKey=result.items?.[0]?.key;
    const fresh=await request('cart.js');
    const oldLine=fresh.items.find(line=>String(line.variant_id)===String(source.variant_id)&&JSON.stringify(line.properties||{})===JSON.stringify(source.properties||{}));
    if(!oldLine)throw Error(copy.changed);
    await request('cart/change.js',{id:oldLine.key,quantity:0});
    const cart=await request('cart.js');render(cart);
   }catch(failure){select.value=previous;error.textContent=added?(copy.review||'Could not finish changing collection. Please review your cart before checkout.'):failure.message;error.hidden=false}
   finally{busy=false;row.removeAttribute('aria-busy');for(const area of [drawer,form])if(area){area.inert=false;area.removeAttribute('aria-busy')}}
  });
  row.append(label,select);details.append(row,error);
 };
})();

